<template>
  <div v-show="show" id="compare-widget" :class="{ 'available': compareItems.length }" @click="toggle">
    <i class="far fa-fw fa-bring-forward"></i>
    <span>Compare</span>
  </div>
</template>

<script>
import bus from '@/plugins/bus';

export default {
  name: 'TheCompareWidget',

  computed: {
    compareItems() {
      return this.$store.state.compare;
    },

    show() {
      const disabledList = [
        'Login',
        'Register',
        'Reset',
        'Forgot',
        'CompareIndex',
        'CompareCategory',
      ];

      return !disabledList.includes(this.$route.name);
    },
  },

  methods: {
    toggle() {
      bus.$emit('toggle-compare-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
  #compare-widget {
    position: fixed;
    right: 0;
    bottom: 3rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 1rem;
    width: 5rem;
    border-radius: 0.25rem 0 0 0.25rem;
    background-color: #333;
    text-align: center;
    color: $white;
    z-index: 200;
    cursor: pointer;
    transition: all 0.3s ease;

    @include media ("<tablet") {
      bottom: 2rem;
      width: 4rem;
      padding: 0.75rem 0.5rem 0.5rem;
    }

    &.available {
      background-color: $color-secondary;
      color: $white;
    }

    &:hover {
      background-color: $color-primary !important;
      color: $black;
      width: 6rem;
    }

    svg {
      display: block;
      margin-bottom: 0.5rem;
      height: 2rem;
      width: 2rem;

      @include media ("<tablet") {
        margin-bottom: 0.5rem;
        height: 1.25rem;
        width: 1.25rem;
      }
    }

    span {
      display: block;
      width: 100%;
      font-size: 0.75rem;

      @include media ("<tablet") {
        font-size: 0.625rem;
      }
    }
  }
</style>
